/**
 * BaseEditSelector component
 * Allows users to select which edit to base their new edit on (parent edit or original)
 * Feature: 006-critique-editing / User Story 2
 */

import type { CritiqueEdit } from '../types/edit.types'

interface BaseEditSelectorProps {
  edits: CritiqueEdit[]
  selectedBaseEditId: string | null
  onSelectBaseEdit: (baseEditId: string | null) => void
  className?: string
}

export function BaseEditSelector({
  edits,
  selectedBaseEditId,
  onSelectBaseEdit,
  className = '',
}: BaseEditSelectorProps) {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <label htmlFor="base-edit-selector" className="text-sm font-medium text-foreground">
        Base your edit on:
      </label>
      <select
        id="base-edit-selector"
        value={selectedBaseEditId || 'original'}
        onChange={(e) => {
          const value = e.target.value
          onSelectBaseEdit(value === 'original' ? null : value)
        }}
        className="block w-full rounded-md border-border shadow-sm focus:border-primary focus:ring-ring sm:text-sm"
        aria-label="Select base edit"
      >
        <option value="original">Original Photo</option>
        {edits.map((edit) => (
          <option key={edit.id} value={edit.id}>
            Edit from {new Date(edit.createdAt).toLocaleString()} ({edit.editType})
          </option>
        ))}
      </select>
      <p className="text-xs text-muted">
        {selectedBaseEditId
          ? 'Your edit will be applied on top of the selected edit'
          : 'Your edit will be applied to the original photo'}
      </p>
    </div>
  )
}
